"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZmapHelper = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lonlatCalculate = require("./lonlatCalculate");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ZmapHelper = exports.ZmapHelper = function () {
  function ZmapHelper(map, gps) {
    var color = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "#f00808";

    _classCallCheck(this, ZmapHelper);

    _initialiseProps.call(this);

    this.map = map;
    this.gps = gps;
    this.color = color;
  }

  _createClass(ZmapHelper, [{
    key: "drawWindLevelText",
    value: function drawWindLevelText(latlon, level, distance) {
      var levelText = "";
      switch (level) {
        case "rr06":
          levelText = "六级";
          break;
        case "rr07":
          levelText = "七级";
          break;
        case "rr08":
          levelText = "八级";
          break;
        case "rr10":
          levelText = "十级";
          break;
      }

      var lonlat = _lonlatCalculate.calculate.destinationVincenty({ lon: latlon[1], lat: latlon[0] }, 180, distance);
      return L.marker([lonlat.lat, lonlat.lon], {
        icon: L.divIcon({
          html: "<span class=\"defense_circle_text\">" + levelText + "</span>"
        })
      });
    }
  }]);

  return ZmapHelper;
}();

var _initialiseProps = function _initialiseProps() {
  var _this = this;

  this.drawTy = function (tyData) {
    var isDrawReal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var isDrawWindCircle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;


    var color = _this.color;
    if (!tyData) {
      console.error("台风数据为空");
      return;
    }
    var map = _this.map;
    var tyName = tyData.tscname,
        tyId = tyData.tsid,
        realPoints = tyData.real,
        fstPoints = tyData.fst.sort(function (a, b) {
      return Number(a.leadtime) - Number(b.leadtime);
    });
    console.log("realPoints", realPoints);
    var realFirstPointDegrees = [];
    if (realPoints.length == 0) {
      return;
    }
    realFirstPointDegrees = [realPoints[realPoints.length - 1].lat, realPoints[realPoints.length - 1].lon];

    var length = realPoints.length;
    var windCircle = length != 0 ? getWindCircle(realPoints[realPoints.length - 1]) : [];
    var isRealLastPoint = false,
        isfstLastPoint = false,
        realPointCounter = 0,
        fstPointCounter = 0,
        realLastPoint = [realPoints[realPoints.length - 1].lon, realPoints[realPoints.length - 1].lat],
        tyLayerGroup = L.layerGroup(),
        layerHolder = void 0,
        popupHolder = void 0,
        realSpeedHolder = [],
        fstSpeedHolder = [],
        fstAreaPointsHolder = [],
        layersGoesBack = [];
    var fstSidePints = [],
        fstSemicilePoints = [],
        fstAreaPoints = [[realPoints[realPoints.length - 1].lat, realPoints[realPoints.length - 1].lon]];
    tyLayerGroup.addTo(map);

    if (realPoints.length == 1) {
      var prePointDgrees = [realPoints[realPoints.length - 1].lon, realPoints[realPoints.length - 1].lat],
          pointDgrees = fstPoints.length ? [fstPoints[0].lon, fstPoints[0].lat] : [],
          timeDiff = fstPoints.length ? Number(fstPoints[0].leadtime) : 0;
      if (fstPoints.length) {
        realSpeedHolder.push(Number(computeDistance(prePointDgrees[0], prePointDgrees[1], pointDgrees[0], pointDgrees[1]) / timeDiff).toFixed(1));
      } else if (fstPoints.length == 1) {
        fstSpeedHolder.push(Number(computeDistance(prePointDgrees[0], prePointDgrees[1], pointDgrees[0], pointDgrees[1]) / timeDiff).toFixed(1));
      } else if (fstPoints.length > 1) {
        fstSpeedHolder.push(Number(computeDistance(prePointDgrees[0], prePointDgrees[1], pointDgrees[0], pointDgrees[1]) / timeDiff).toFixed(1));
        fstPoints.forEach(function (el, i, arr) {
          if (i == 0) return;
          timeDiff = arr[i].leadtime - arr[i - 1].leadtime;
          fstSpeedHolder.push(Number(computeDistance(arr[i - 1].lon, arr[i - 1].lat, arr[i].lon, arr[i].lat) / timeDiff).toFixed(1));
        });
      }
    } else {
      var _prePointDgrees = [realPoints[0].lon, realPoints[0].lat],
          _pointDgrees = [realPoints[1].lon, realPoints[1].lat],
          _timeDiff = getDateDiff(realPoints[0].datetime, realPoints[1].datetime, "h");
      realSpeedHolder.push(Number(computeDistance(_prePointDgrees[0], _prePointDgrees[1], _pointDgrees[0], _pointDgrees[1]) / _timeDiff).toFixed(1));
      realPoints.forEach(function (el, i, arr) {
        if (i == 0) return;
        _timeDiff = getDateDiff(arr[i - 1].datetime, arr[i].datetime, "h");
        realSpeedHolder.push(Number(computeDistance(arr[i - 1].lon, arr[i - 1].lat, arr[i].lon, arr[i].lat) / _timeDiff).toFixed(1));
      });
      if (fstPoints.length == 1) {
        _prePointDgrees = [realPoints[realPoints.length - 1].lon, realPoints[realPoints.length - 1].lat];
        _pointDgrees = [fstPoints[0].lon, fstPoints[0].lat];
        _timeDiff = Number(fstPoints[0].leadtime);
        fstSpeedHolder.push(Number(computeDistance(_prePointDgrees[0], _prePointDgrees[1], _pointDgrees[0], _pointDgrees[1]) / _timeDiff).toFixed(1));
      } else if (fstPoints.length > 1) {
        _prePointDgrees = [realPoints[realPoints.length - 1].lon, realPoints[realPoints.length - 1].lat];
        _pointDgrees = [fstPoints[0].lon, fstPoints[0].lat];
        _timeDiff = Number(fstPoints[0].leadtime);
        fstSpeedHolder.push(Number(computeDistance(_prePointDgrees[0], _prePointDgrees[1], _pointDgrees[0], _pointDgrees[1]) / _timeDiff).toFixed(1));

        fstPoints.forEach(function (el, i, arr) {
          if (i == 0) return;
          _timeDiff = arr[i].leadtime - arr[i - 1].leadtime;
          fstSpeedHolder.push(Number(computeDistance(arr[i - 1].lon, arr[i - 1].lat, arr[i].lon, arr[i].lat) / _timeDiff).toFixed(1));
        });
      }
    }

    if (fstPoints.length >= 1) {
      fstPoints.forEach(function (el, i, arr) {
        if (i == 0) {
          fstSidePints.push(getSidePoints(realPoints[realPoints.length - 1].lon, realPoints[realPoints.length - 1].lat, el.lon, el.lat, getFstR(el.leadtime)));
        } else {
          fstSidePints.push(getSidePoints(arr[i - 1].lon, arr[i - 1].lat, el.lon, el.lat, getFstR(el.leadtime)));
        }
      });

      var isLeftBigger = false;
      if (fstSidePints[fstSidePints.length - 1].left.lat > fstSidePints[fstSidePints.length - 1].right.lat) {
        isLeftBigger = true;
      }

      fstSemicilePoints = getHalfPoints(fstSidePints[fstSidePints.length - 1].right, fstSidePints[fstSidePints.length - 1].left, 45, isLeftBigger);

      fstSidePints.forEach(function (el) {
        fstAreaPointsHolder.push(el.left.lat, el.left.lon);
      });
      fstAreaPointsHolder = getCurvePoints(fstAreaPointsHolder, 0.5, 10, false);
      for (var i = 0; i < fstAreaPointsHolder.length; i += 2) {
        fstAreaPoints.push([fstAreaPointsHolder[i], fstAreaPointsHolder[i + 1]]);
      }
      fstAreaPointsHolder = [];
      if (isLeftBigger == true) {
        for (var _i = 0; _i < fstSemicilePoints.length; _i += 2) {
          fstAreaPoints.push([fstSemicilePoints[_i + 1], fstSemicilePoints[_i]]);
        }
      } else {
        for (var _i2 = fstSemicilePoints.length - 1; _i2 > 0; _i2 -= 2) {
          fstAreaPoints.push([fstSemicilePoints[_i2], fstSemicilePoints[_i2 - 1]]);
        }
      }

      fstSidePints.reverse().forEach(function (el) {
        fstAreaPointsHolder.push(el.right.lat, el.right.lon);
      });
      fstAreaPointsHolder = getCurvePoints(fstAreaPointsHolder, 0.5, 10, false);
      for (var _i3 = 0; _i3 < fstAreaPointsHolder.length; _i3 += 2) {
        fstAreaPoints.push([fstAreaPointsHolder[_i3], fstAreaPointsHolder[_i3 + 1]]);
      }
      fstAreaPointsHolder = [];

      fstSidePints.reverse();
    }
    var tipHolder = L.marker(realPoints[realPoints.length - 1]);
    var tipPosMk = "";
    if (isDrawReal) {
      if (realPoints.length) {
        var tyNameLabel = L.divIcon({
          className: "ty-name-label",
          html: "<span style=\"color:black;text-shadow: #ffffff 0.5px 0 0, #ffffff 0 0.5px 0, #ffffff -0.5px 0 0, #ffffff 0 -0.5px 0;\n                \">" + tyName + (tyData.tsename && tyData.tsename.indexOf("*") === -1 ? tyData.tsename : "") + "</span>",
          iconAnchor: [-15, 9]
        });
        tyLayerGroup.addLayer(L.marker([realPoints[0].lat, realPoints[0].lon], {
          icon: tyNameLabel
        }));
      }

      var divIcon = L.divIcon({});

      var _tipHolder = L.marker(realPoints[realPoints.length - 1], {
        icon: divIcon
      });

      console.log("realFirstPointDegrees", realFirstPointDegrees);
      var iconClass = realFirstPointDegrees[0] > 0 ? "rotate_ani" : "positive_rotate_ani";
      var curMarker = L.divIcon({
        className: "typhoon_icon",
        html: "<div ><img class=\"" + iconClass + "\" style=\"width:30px;height:30px\" src=\"" + getCurMKByLevel(realPoints[realPoints.length - 1]) + "\"></div>"
      });
      var curPosMk = L.marker(realFirstPointDegrees, {
        icon: curMarker,
        zIndexOffset: 2000
      }).on("click", function (e) {
        if (tipPosMk) {
          tipPosMk.setOpacity(1);
        }

        var popup = createTyPointPopup(realPoints[realPoints.length - 1], true);

        e.target.unbindPopup().bindPopup(popup).openPopup();
        _tipHolder.setOpacity(1);
      });
      tyLayerGroup.addLayer(curPosMk);
      console.log("tyData.tsid===649", tyData);
      if (tyData.tsid === "649") {
        var tipMarker = L.divIcon({
          className: "ty-name",
          html: "<div style='width:200px;text-align:left;transform: translateX(-50%) translateY(60%);'><p>\u76EE\u524D\u70ED\u5E26\u4F4E\u538B\u5F3A\u5EA6\u51CF\u5F31\uFF0C\u4E91\u7CFB\u5206\u6563\uFF0C</p>\u4E2D\u592E\u6C14\u8C61\u53F0\u4E0D\u518D\u53D1\u5E03\u5176\u4E2D\u5FC3\u4F4D\u7F6E</div>"
        });
        tipPosMk = L.marker(realFirstPointDegrees, {
          icon: tipMarker,
          zIndexOffset: -2000
        }).on("click", function (e) {
          var popup = createTyPointPopup(realPoints[realPoints.length - 1], true);
          e.target.unbindPopup().bindPopup(popup).openPopup();
          tipPosMk.setOpacity(1);
        });
        tyLayerGroup.addLayer(tipPosMk);
      }

      if (realPoints.length == 1) {
        curPosMk.setLatLng([realPoints[realPointCounter].lat, realPoints[realPointCounter].lon]);

        popupHolder = createTyPointPopup(realPoints[realPointCounter], true);
        tyLayerGroup.addLayer(L.circleMarker([realPoints[realPoints.length - 1].lat, realPoints[realPoints.length - 1].lon], {
          zIndexOffset: 2000,
          radius: 6,
          weight: 1.5,
          color: getColorByLevel(realPoints[realPointCounter].level, true),
          opacity: 1,
          fillOpacity: 1,
          fillColor: getColorByLevel(realPoints[realPointCounter].level)
        }).bindPopup(popupHolder));
        curPosMk.setLatLng([realPoints[realPoints.length - 1].lat, realPoints[realPoints.length - 1].lon]);
        if (tyData.tsid !== "649") {
          tyLayerGroup.addLayer(_tipHolder);
        }

        var realPointsInterval = setInterval(function () {
          layerHolder = L.polyline([[realPoints[realPoints.length - 1].lat, realPoints[realPoints.length - 1].lon], [fstPoints[fstPointCounter].lat, fstPoints[fstPointCounter].lon]], {
            dashArray: "15, 10",
            dashOffset: "8",
            color: color,
            weight: 3
          });
          tyLayerGroup.addLayer(layerHolder);
          layerHolder.bringToBack();
          layersGoesBack.push({
            layer: layerHolder
          });
          clearInterval(realPointsInterval);
          var fstPointsInterval = setInterval(function () {
            if (fstPointCounter != fstPoints.length - 1) {
              popupHolder = createTyPointPopup(fstPoints[fstPointCounter]);
              tyLayerGroup.addLayer(L.circleMarker([fstPoints[fstPointCounter].lat, fstPoints[fstPointCounter].lon], {
                zIndexOffset: 2000,
                radius: 6,

                color: getColorByLevel(fstPoints[fstPointCounter].level, true),
                weight: 1,
                opacity: 1,
                fillOpacity: 1,

                fillColor: getColorByLevel(fstPoints[fstPointCounter].level)
              }).bindPopup(popupHolder));

              if (fstPointCounter > 0) {
                layerHolder = L.polyline([[fstPoints[fstPointCounter - 1].lat, fstPoints[fstPointCounter - 1].lon], [fstPoints[fstPointCounter].lat, fstPoints[fstPointCounter].lon]], {
                  dashArray: "8, 8",
                  dashOffset: "10",
                  color: color,
                  weight: 3
                });
                tyLayerGroup.addLayer(layerHolder);
                layerHolder.bringToBack();
                layersGoesBack.push({
                  layer: layerHolder
                });
              }
              fstPointCounter++;
            } else {
              clearInterval(fstPointsInterval);
              popupHolder = createTyPointPopup(fstPoints[fstPoints.length - 1]);
              tyLayerGroup.addLayer(L.circleMarker([fstPoints[fstPoints.length - 1].lat, fstPoints[fstPoints.length - 1].lon], {
                zIndexOffset: 2000,
                radius: 6,
                color: getColorByLevel(fstPoints[fstPoints.length - 1].level, true),
                weight: 1,
                opacity: 1,
                fillOpacity: 1,
                fillColor: getColorByLevel(fstPoints[fstPoints.length - 1].level)
              }).bindPopup(popupHolder));

              if (fstPoints.length > 1) {
                layerHolder = L.polyline([[fstPoints[fstPoints.length - 2].lat, fstPoints[fstPoints.length - 2].lon], [fstPoints[fstPoints.length - 1].lat, fstPoints[fstPoints.length - 1].lon]], {
                  dashArray: "8, 8",
                  dashOffset: "10",
                  color: color,
                  weight: 3
                });
                tyLayerGroup.addLayer(layerHolder);
                layerHolder.bringToBack();
                layersGoesBack.push({
                  layer: layerHolder
                });
              }

              var lastPoint = realLastPoint,
                  lastPointData = realPoints[realPoints.length - 1];

              if (lastPoint[0] > lastPoint[1]) lastPoint.reverse();
              if (isDrawWindCircle) {
                for (var _i4 in windCircle) {
                  tyLayerGroup.addLayer(L.circle(lastPoint, lastPointData[_i4] * 1000, {
                    zIndexOffset: 2000,
                    color: getWindColor(_i4),
                    weight: 3,
                    fill: false
                  }));

                  tyLayerGroup.addLayer(_this.drawWindLevelText(lastPoint, _i4, lastPointData[_i4] * 1000));
                }
              }

              _this.map.on("click", function () {
                _tipHolder.setOpacity(0);
                if (tipPosMk) {
                  tipPosMk.setOpacity(0);
                }
              });
            }
          }, 1);
        }, 1);
      }

      if (realPoints.length > 1) {
        var _realPointsInterval = setInterval(function () {
          if (realPointCounter != realPoints.length - 1) {
            if (!map.hasLayer(tyLayerGroup)) {
              return;
            }

            if (realPointCounter > 0) {
              layerHolder = L.polyline([[realPoints[realPointCounter - 1].lat, realPoints[realPointCounter - 1].lon], [realPoints[realPointCounter].lat, realPoints[realPointCounter].lon]], {
                color: getColorByLevel(realPoints[realPointCounter].level),
                weight: 3
              });
              tyLayerGroup.addLayer(layerHolder);
              layerHolder.bringToBack();
              layersGoesBack.push({
                layer: layerHolder
              });
            }
            popupHolder = createTyPointPopup(realPoints[realPointCounter], true, realPointCounter);
            tyLayerGroup.addLayer(L.circleMarker([realPoints[realPointCounter].lat, realPoints[realPointCounter].lon], {
              zIndexOffset: 2000,
              radius: 6,
              weight: 1,
              color: getColorByLevel(realPoints[realPointCounter].level, true),
              opacity: 1,
              fillOpacity: 1,
              fillColor: getColorByLevel(realPoints[realPointCounter].level)
            }).bindPopup(popupHolder));

            realPointCounter++;
            curPosMk.setLatLng([realPoints[realPointCounter].lat, realPoints[realPointCounter].lon]);
          } else {
            clearInterval(_realPointsInterval);

            popupHolder = createTyPointPopup(realPoints[realPointCounter], false, realPoints.length - 1);
            tyLayerGroup.addLayer(L.circleMarker([realPoints[realPoints.length - 1].lat, realPoints[realPoints.length - 1].lon], {
              radius: 6,
              weight: 1.5,
              color: getColorByLevel(realPoints[realPointCounter].level, true),
              opacity: 1,
              fillOpacity: 1,
              fillColor: getColorByLevel(realPoints[realPointCounter].level)
            }).bindPopup(popupHolder));
            curPosMk.setLatLng([realPoints[realPoints.length - 1].lat, realPoints[realPoints.length - 1].lon]);
            var leg = realPoints[realPoints.length - 1].datetime.length;
            var time = realPoints[realPoints.length - 1].datetime.substring(0, leg - 6);
            var _divIcon = L.divIcon({
              className: "ty-name",
              iconSize: [0, 0],
              html: "<div><p>" + (tyName ? tyName : "热带低压") + " " + time + "\u65F6</p>\n                           \t<p>\u7EA6\u79BB" + window.locationInfo.city + "\u4E2D\u5FC3" + computeDistance(_this.gps[1], _this.gps[0], realPoints[realPoints.length - 1].lon, realPoints[realPoints.length - 1].lat) + "\u516C\u91CC</p>\n                           \t</div>"
            });
            var _tipHolder2 = L.marker([realPoints[realPoints.length - 1].lat, realPoints[realPoints.length - 1].lon], {
              icon: _divIcon
            });
            if (tyData.tsid !== "649") {
              tyLayerGroup.addLayer(_tipHolder2);
            }

            layerHolder = L.polyline([[realPoints[realPoints.length - 2].lat, realPoints[realPoints.length - 2].lon], [realPoints[realPoints.length - 1].lat, realPoints[realPoints.length - 1].lon]], {
              color: getColorByLevel(realPoints[realPoints.length - 1].level),
              weight: 3
            });
            tyLayerGroup.addLayer(layerHolder);
            layerHolder.bringToBack();
            layersGoesBack.push({
              layer: layerHolder
            });

            if (fstPoints.length >= 1) {
              layerHolder = L.polyline([[realPoints[realPoints.length - 1].lat, realPoints[realPoints.length - 1].lon], [fstPoints[fstPointCounter].lat, fstPoints[fstPointCounter].lon]], {
                dashArray: "15, 10",
                dashOffset: "8",
                color: color,
                weight: 3
              });
              tyLayerGroup.addLayer(layerHolder);
              layerHolder.bringToBack();
              layersGoesBack.push({
                layer: layerHolder
              });
              var fstPointsInterval = setInterval(function () {
                if (fstPointCounter != fstPoints.length - 1) {
                  popupHolder = createTyPointPopup(fstPoints[fstPointCounter], false, fstPointCounter);
                  tyLayerGroup.addLayer(L.circleMarker([fstPoints[fstPointCounter].lat, fstPoints[fstPointCounter].lon], {
                    zIndexOffset: 2000,
                    radius: 6,
                    color: getColorByLevel(fstPoints[fstPointCounter].level, true),
                    weight: 1,
                    opacity: 1,
                    fillOpacity: 1,
                    fillColor: getColorByLevel(fstPoints[fstPointCounter].level)
                  }).bindPopup(popupHolder));

                  if (fstPointCounter > 0) {
                    layerHolder = L.polyline([[fstPoints[fstPointCounter - 1].lat, fstPoints[fstPointCounter - 1].lon], [fstPoints[fstPointCounter].lat, fstPoints[fstPointCounter].lon]], {
                      dashArray: "8, 8",
                      dashOffset: "10",
                      color: color,
                      weight: 3
                    });
                    tyLayerGroup.addLayer(layerHolder);
                    layerHolder.bringToBack();
                    layersGoesBack.push({
                      layer: layerHolder
                    });
                  }
                  fstPointCounter++;
                } else {
                  clearInterval(fstPointsInterval);
                  popupHolder = createTyPointPopup(fstPoints[fstPoints.length - 1], false, fstPoints.length - 1);
                  tyLayerGroup.addLayer(L.circleMarker([fstPoints[fstPoints.length - 1].lat, fstPoints[fstPoints.length - 1].lon], {
                    zIndexOffset: 2000,
                    radius: 6,
                    color: getColorByLevel(fstPoints[fstPoints.length - 1].level, true),
                    weight: 1,
                    opacity: 1,
                    fillOpacity: 1,
                    fillColor: getColorByLevel(fstPoints[fstPoints.length - 1].level)
                  }).bindPopup(popupHolder));

                  if (fstPoints.length > 1) {
                    layerHolder = L.polyline([[fstPoints[fstPoints.length - 2].lat, fstPoints[fstPoints.length - 2].lon], [fstPoints[fstPoints.length - 1].lat, fstPoints[fstPoints.length - 1].lon]], {
                      dashArray: "8, 8",
                      dashOffset: "10",
                      color: color,
                      weight: 3
                    });
                    tyLayerGroup.addLayer(layerHolder);
                    layerHolder.bringToBack();
                    layersGoesBack.push({
                      layer: layerHolder
                    });
                  }


                  if (!window.fstAreas) window.fstAreas = [];
                  if (window.fstAreas.length < window.currentTyNum) window.fstAreas.push(fstAreaPoints);

                  var lastPoint = realLastPoint,
                      lastPointData = realPoints[realPoints.length - 1];

                  if (lastPoint[0] > lastPoint[1]) lastPoint.reverse();
                  if (isDrawWindCircle) {
                    for (var _i5 in windCircle) {
                      tyLayerGroup.addLayer(L.circle(lastPoint, lastPointData[_i5] * 1000, {
                        zIndexOffset: 2000,
                        color: getWindColor(_i5),
                        weight: 1,
                        fill: false
                      }));
                      tyLayerGroup.addLayer(_this.drawWindLevelText(lastPoint, _i5, lastPointData[_i5] * 1000));
                    }
                  }

                  _this.map.on("click", function () {
                    _tipHolder2.remove();
                    if (tipPosMk) {
                      tipPosMk.setOpacity(0);
                    }
                  });
                }
              }, 1);
            } else {
              if (!window.fstAreas) window.fstAreas = [];
              if (window.fstAreas.length < window.currentTyNum) window.fstAreas.push(fstAreaPoints);
            }
          }
        }, 1);
      }
      console.log("real>>>>>1", tyLayerGroup);
    } else {
      if (fstPoints.length >= 1) {
        layerHolder = L.polyline([[realPoints[realPoints.length - 1].lat, realPoints[realPoints.length - 1].lon], [fstPoints[fstPointCounter].lat, fstPoints[fstPointCounter].lon]], {
          dashArray: "15, 10",
          dashOffset: "8",
          color: color,
          weight: 3
        });
        tyLayerGroup.addLayer(layerHolder);
        layerHolder.bringToBack();
        layersGoesBack.push({
          layer: layerHolder
        });
        var fstPointsInterval = setInterval(function () {
          if (fstPointCounter != fstPoints.length - 1) {
            popupHolder = createTyPointPopup(fstPoints[fstPointCounter], false, fstPointCounter);
            tyLayerGroup.addLayer(L.circleMarker([fstPoints[fstPointCounter].lat, fstPoints[fstPointCounter].lon], {
              zIndexOffset: 2000,
              radius: 6,
              color: getColorByLevel(fstPoints[fstPointCounter].level, true),
              weight: 1,
              opacity: 1,
              fillOpacity: 1,
              fillColor: getColorByLevel(fstPoints[fstPointCounter].level)
            }).bindPopup(popupHolder));

            if (fstPointCounter > 0) {
              layerHolder = L.polyline([[fstPoints[fstPointCounter - 1].lat, fstPoints[fstPointCounter - 1].lon], [fstPoints[fstPointCounter].lat, fstPoints[fstPointCounter].lon]], {
                dashArray: "8, 8",
                dashOffset: "10",
                color: color,
                weight: 3
              });
              tyLayerGroup.addLayer(layerHolder);
              layerHolder.bringToBack();
              layersGoesBack.push({
                layer: layerHolder
              });
            }
            fstPointCounter++;
          } else {
            clearInterval(fstPointsInterval);
            popupHolder = createTyPointPopup(fstPoints[fstPoints.length - 1], false, fstPoints.length - 1);
            tyLayerGroup.addLayer(L.circleMarker([fstPoints[fstPoints.length - 1].lat, fstPoints[fstPoints.length - 1].lon], {
              zIndexOffset: 2000,
              radius: 6,
              color: getColorByLevel(fstPoints[fstPoints.length - 1].level, true),
              weight: 1,
              opacity: 1,
              fillOpacity: 1,
              fillColor: getColorByLevel(fstPoints[fstPoints.length - 1].level)
            }).bindPopup(popupHolder));

            if (fstPoints.length > 1) {
              layerHolder = L.polyline([[fstPoints[fstPoints.length - 2].lat, fstPoints[fstPoints.length - 2].lon], [fstPoints[fstPoints.length - 1].lat, fstPoints[fstPoints.length - 1].lon]], {
                dashArray: "8, 8",
                dashOffset: "10",
                color: color,
                weight: 3
              });
              tyLayerGroup.addLayer(layerHolder);
              layerHolder.bringToBack();
              layersGoesBack.push({
                layer: layerHolder
              });
            }


            if (!window.fstAreas) window.fstAreas = [];
            if (window.fstAreas.length < window.currentTyNum) window.fstAreas.push(fstAreaPoints);

            var lastPoint = realLastPoint,
                lastPointData = realPoints[realPoints.length - 1];

            if (lastPoint[0] > lastPoint[1]) lastPoint.reverse();
            if (isDrawWindCircle) {
              for (var _i6 in windCircle) {
                tyLayerGroup.addLayer(L.circle(lastPoint, lastPointData[_i6] * 1000, {
                  zIndexOffset: 2000,
                  color: getWindColor(_i6),
                  weight: 1,
                  fill: false
                }));
                tyLayerGroup.addLayer(_this.drawWindLevelText(lastPoint, _i6, lastPointData[_i6] * 1000));
              }
            }

            _this.map.on("click", function () {
              tipHolder.remove();
              if (tipPosMk) {
                tipPosMk.setOpacity(0);
              }
            });
          }
        }, 1);
      } else {
        if (!window.fstAreas) window.fstAreas = [];
        if (window.fstAreas.length < window.currentTyNum) window.fstAreas.push(fstAreaPoints);
      }
    }

    function createTyPointPopup(data) {
      var isRealPoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var order = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      var n = void 0;
      if (isRealPoint) {
        n = new Date(data.datetime.replace(/\-/g, "/"));

        var ws = void 0,
            ps = void 0;
        if (!data.ws) {
          ws = "无";
        } else {
          ws = data.ws + "米/秒";
        }
        if (!data.ps) {
          ps = "无";
        } else {
          ps = data.ps + "hpa";
        }
        return L.popup({
          className: "ty-popup",
          closeButton: false
        }).setContent("<section>\n                <ul>\n                    <li><span>\u5E74\u6708\u4EFD</span><span>" + n.getFullYear() + "\u5E74" + (n.getMonth() + 1) + "\u6708</span></li>\n                    <li><span>\u65F6\u95F4</span><span>" + n.getDate() + "\u65E5" + (n.getHours() < 10 ? "0" + n.getHours() : n.getHours()) + "\u65F6</span></li>\n                    <li><span>\u5F53\u524D\u4F4D\u7F6E</span><span>" + data.lon.toFixed(1) + "\xB0/" + data.lat.toFixed(1) + "\xB0</span></li>\n                    <li><span>\u7B49\u7EA7</span><span>" + getRankByLevel(data.level) + "</span></li>\n                    <li><span>\u98CE\u529B</span><span>" + getVelLevel(data.ws) + "</span></li>\n                    <li> <span> \u98CE\u901F </span><span>" + ws + "</span></li>\n                    <li><span>\u4E2D\u5FC3\u6C14\u538B</span><span>" + ps + "</span></li>\n                    <li><span>\u4E03\u7EA7\u98CE\u5708</span><span>" + (data.rr07 ? data.rr07 + "公里" : "无") + "</span></li>\n                    <li><span>\u5341\u7EA7\u98CE\u5708</span><span>" + (data.rr10 ? data.rr10 + "公里" : "无") + "</span></li>\n                    <li><span>\u8DDD" + window.locationInfo.city + "</span><span>" + computeDistance(window.locationInfo.lon, window.locationInfo.lat, data.lon, data.lat) + "\u516C\u91CC</sapn></li>\n                </ul>\n                <div class=\"bgLeft\">\n                    <div class=\"bgLeftInt\"></div>\n                </div>\n                </section>");
      } else {
        n = new Date(data.datetime.replace(/\-/g, "/"));

        n.setHours(n.getHours() + data.leadtime);
        var _ws = void 0,
            _ps = void 0;
        if (!data.ws) {
          _ws = "无";
        } else {
          _ws = data.ws + "米/秒";
        }
        if (!data.ps) {
          _ps = "无";
        } else {
          _ps = data.ps + "hpa";
        }
        return L.popup({
          className: "ty-popup",
          closeButton: false
        }).setContent("<section>\n                <ul>\n                   <li><span>\u5E74\u6708\u4EFD</span><span>" + n.getFullYear() + "\u5E74" + (n.getMonth() + 1) + "\u6708</span></li>\n                   <li><span>\u65F6\u95F4</span><span>" + n.getDate() + "\u65E5" + (n.getHours() < 10 ? "0" + n.getHours() : n.getHours()) + "\u65F6</span></li>\n                   <li><span>\u9884\u8BA1\u4F4D\u7F6E</span><span>" + data.lon.toFixed(1) + "\xB0/" + data.lat.toFixed(1) + "\xB0</span></li>\n                   <li><span>\u7B49\u7EA7</span><span>" + getRankByLevel(data.level) + "</span></li>\n                   <li><span>\u98CE\u529B</span><span>" + getVelLevel(data.ws) + "</span></li>\n                   <li><span>\u98CE\u901F</span><span>" + _ws + "</span></li>\n                   <li><span>\u4E2D\u5FC3\u6C14\u538B</span><span>" + _ps + "</span></li>\n                   <li><span>\u4E03\u7EA7\u98CE\u5708</span><span>" + (data.rr07 ? data.rr07 + "公里" : "无") + "</span></li>\n                   <li><span>\u5341\u7EA7\u98CE\u5708</span><span>" + (data.rr10 ? data.rr10 + "公里" : "无") + "</span></li>\n                   <li><span>\u8DDD" + window.locationInfo.city + "</span><span>" + computeDistance(window.locationInfo.lon, window.locationInfo.lat, data.lon, data.lat) + "\u516C\u91CC</sapn></li>\n                </ul>\n                 <div class=\"bgLeft\">\n                    <div class=\"bgLeftInt\"></div>\n                </div>\n                </section>");
      }
    }

    function getRankByLevel(level) {
      var v = level.replace(/\s+/g, "").toUpperCase();
      v = v.substring(0, 5);

      switch (v) {
        case "TD":
          return "热带低压";
        case "TS":
          return "热带风暴";
        case "STS":
          return "强热带风暴";
        case "TY":
          return "台风";
        case "STY":
          return "强台风";
        case "SUPER":
        case "SUPER TY":
          return "超强台风";
        default:
          return "热带低压";
      }
    }

    function getColorByLevel(level, outline) {
      if (!level) return "#efd340";
      var v = level.replace(/\s+/g, "").toUpperCase();
      v = v.substring(0, 5);

      if (!outline) {
        switch (v) {
          case "TD":
            return "#efd340";
          case "TS":
            return "#0000ff";
          case "STS":
            return "#0f8000";
          case "TY":
            return "#fe9c45";
          case "STY":
            return "#fe00fe";
          case "SUPER":
          case "SUPER TY":
            return "#fe0000";
          default:
            return "#efd340";
        }
      }
      if (outline == true) {
        switch (v) {
          case "TD":
            return "#7e8029";
          case "TS":
            return "#4b6680";
          case "STS":
            return "#5c7e4e";
          case "TY":
            return "#80630d";
          case "STY":
            return "#980098";
          case "SUPER":
          case "SUPER TY":
            return "#802222";
          default:
            return "#5c7e4e";
        }
      }
    }

    function getSidePoints(lon1, lat1, lon2, lat2, r) {
      var dltLon = lon2 - lon1;
      var dltLat = lat2 - lat1;
      var dltLon2 = dltLon * dltLon;
      var dltLat2 = dltLat * dltLat;
      var dis1 = Math.sqrt(dltLon2 + dltLat2);
      var dis2 = r / 100.0;
      return {
        left: {
          lat: (dltLon * dis1 * dis2 + lat2 * dltLon2 + dltLat2 * lat2) / (dltLon2 + dltLat2),
          lon: (dltLon2 * lon2 + dltLat2 * lon2 - dis1 * dis2 * dltLat) / (dltLon2 + dltLat2)
        },
        right: {
          lat: (-dltLon * dis1 * dis2 + lat2 * dltLon2 + dltLat2 * lat2) / (dltLon2 + dltLat2),
          lon: (dltLon2 * lon2 + dltLat2 * lon2 + dis1 * dis2 * dltLat) / (dltLon2 + dltLat2)
        }
      };
    }

    function getFstR(value) {
      var tanDis = {
        6: 3 * 8,
        12: 6 * 8,
        18: 10 * 8,
        24: 14 * 8,
        36: 19 * 8,
        48: 24 * 8,
        60: 30 * 8,
        72: 32 * 8,
        84: 40 * 8,
        96: 42 * 8,
        108: 48 * 8,
        120: 50 * 8
      };
      return tanDis[value];
    }

    function getHalfPoints(left, right, num, latJuge) {
      var pois = [];
      var c = {
        lon: (left.lon + right.lon) / 2,
        lat: (left.lat + right.lat) / 2
      };
      var r = Math.sqrt((left.lon - right.lon) * (left.lon - right.lon) + (left.lat - right.lat) * (left.lat - right.lat)) / 2;
      var start = Math.atan((left.lon - c.lon) / (left.lat - c.lat));
      var dis = Math.PI;
      var step = dis / num;
      if (!latJuge) {
        for (var i = 1; i < num; i++) {
          var angle = start - i * step;
          pois.push(c.lon + r * Math.sin(angle), c.lat + r * Math.cos(angle));
        }
      }
      if (latJuge) {
        for (var i = 1; i < num; i++) {
          var angle = start + i * step;
          pois.push(c.lon + r * Math.sin(angle), c.lat + r * Math.cos(angle));
        }
      }
      return pois;
    }

    function getWindCircle(point) {
      var temp = {};
      if (point.rr06) {
        temp.rr06 = point.rr06;
      }
      if (point.rr07) {
        temp.rr07 = point.rr07;
      }
      if (point.rr08) {
        temp.rr08 = point.rr08;
      }
      if (point.rr10) {
        temp.rr10 = point.rr10;
      }
      return temp;
    }

    function getWindColor(level) {
      switch (level) {
        case "rr06":
          return "#15fe16";
        case "rr07":
          return "#181dfd";
        case "rr08":
          return "#f5fa17";
        case "rr10":
          return "#fe0406";
      }
    }

    function getWindCirclePoint(lon, lat, r) {
      var points = [],
          angle = 360;
      var dis = Math.PI;
      var R = r / 100;
      for (var _i7 = 0; _i7 < 360; _i7++) {
        points.push([lat + R * Math.sin(_i7 * dis / 180), lon + R * Math.cos(_i7 * dis / 180)]);
      }
      return points;
    }

    function getCurMKByLevel(lastPoint) {
      var v = lastPoint.level.replace(/\s+/g, "").toUpperCase();
      v = v.substring(0, 5);

      switch (v) {
        case "TD":
          return "./assets/typhoonstatic_03.png";
        case "TS":
          return "./assets/typhoonstatic_02.png";
        case "STS":
          return "./assets/typhoonstatic_01.png";
        case "TY":
          return "./assets/typhoonstatic_04.png";
        case "STY":
          return "./assets/typhoonstatic_05.png";
        case "SUPER":
        case "SUPER TY":
          return "./assets/typhoonstatic_06.png";
        default:
          return "./assets/typhoonstatic_03.png";
      }
    }

    function computeDistance(lng1, lat1, lng2, lat2) {
      return Math.floor(L.latLng(lat1, lng1).distanceTo(L.latLng(lat2, lng2)) / 100) / 10;
    }

    function getDateDiff(startTime, endTime, diffType) {
      startTime = startTime.replace(/\-/g, "/");
      endTime = endTime.replace(/\-/g, "/");

      diffType = diffType.toLowerCase();
      var sTime = new Date(startTime);
      var eTime = new Date(endTime);
      var divNum = 1;
      switch (diffType) {
        case "s":
          divNum = 1000;
          break;
        case "m":
          divNum = 1000 * 60;
          break;
        case "h":
          divNum = 1000 * 3600;
          break;
        case "d":
          divNum = 1000 * 3600 * 24;
          break;
        default:
          divNum = 1000 * 3600;
          break;
      }
      return parseInt((eTime.getTime() - sTime.getTime()) / parseInt(divNum));
    }

    function getCurvePoints(points, tension, numOfSeg, close) {
      if (typeof points === "undefined" || points.length < 2) return new Float32Array(0);

      tension = typeof tension === "number" ? tension : 0.5;
      numOfSeg = typeof numOfSeg === "number" ? numOfSeg : 25;
      var pts,
          i = 1,
          l = points.length,
          rPos = 0,
          rLen = (l - 2) * numOfSeg + 2 + (close ? 2 * numOfSeg : 0),
          res = new Float32Array(rLen),
          cache = new Float32Array(numOfSeg + 2 << 2),
          cachePtr = 4;
      pts = points.slice(0);
      if (close) {
        pts.unshift(points[l - 1]);
        pts.unshift(points[l - 2]);
        pts.push(points[0], points[1]);
      } else {
        pts.unshift(points[1]);
        pts.unshift(points[0]);
        pts.push(points[l - 2], points[l - 1]);
      }

      cache[0] = 1;
      for (; i < numOfSeg; i++) {
        var st = i / numOfSeg,
            st2 = st * st,
            st3 = st2 * st,
            st23 = st3 * 2,
            st32 = st2 * 3;
        cache[cachePtr++] = st23 - st32 + 1;
        cache[cachePtr++] = st32 - st23;
        cache[cachePtr++] = st3 - 2 * st2 + st;
        cache[cachePtr++] = st3 - st2;
      }
      cache[++cachePtr] = 1;
      parse(pts, cache, l, tension);
      if (close) {
        pts = [];
        pts.push(points[l - 4], points[l - 3], points[l - 2], points[l - 1], points[0], points[1], points[2], points[3]);
        parse(pts, cache, 4, tension);
      }

      function parse(pts, cache, l, tension) {
        for (var i = 2, t; i < l; i += 2) {
          var pt1 = pts[i],
              pt2 = pts[i + 1],
              pt3 = pts[i + 2],
              pt4 = pts[i + 3],
              t1x = (pt3 - pts[i - 2]) * tension,
              t1y = (pt4 - pts[i - 1]) * tension,
              t2x = (pts[i + 4] - pt1) * tension,
              t2y = (pts[i + 5] - pt2) * tension,
              c = 0,
              c1,
              c2,
              c3,
              c4;
          for (t = 0; t < numOfSeg; t++) {
            c1 = cache[c++];
            c2 = cache[c++];
            c3 = cache[c++];
            c4 = cache[c++];
            res[rPos++] = c1 * pt1 + c2 * pt3 + c3 * t1x + c4 * t2x;
            res[rPos++] = c1 * pt2 + c2 * pt4 + c3 * t1y + c4 * t2y;
          }
        }
      }

      l = close ? 0 : points.length - 2;
      res[rPos++] = points[l++];
      res[rPos] = points[l];
      return res;
    }

    function getVelLevel(vel) {
      var levels = [0.3, 1.6, 3.4, 5.5, 8.0, 10.8, 13.9, 17.2, 20.8, 24.5, 28.5, 32.7, 37.0, 41.5, 46.2, 51.0, 56.1, 61.3];

      for (var _i8 = 0; _i8 < levels.length; _i8++) {
        if (vel < levels[_i8]) return _i8 + "级";
      }
      return "无";
    }
    console.log("tyLayerGroup", tyLayerGroup);
    return {
      realLastPoint: realLastPoint,
      tyLayerGroup: tyLayerGroup,
      layersGoesBack: layersGoesBack
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/util/ZmapHelper.js
// module id = 13
// module chunks = 0